export default class Page {
    number
    page
    size
    totalElements
    totalPages

    constructor(props) {
        const pp = props || {}
        this.number = pp.number || 1
        this.page = this.number - 1
        this.size = pp.size || 10
        this.totalPages = pp.totalPages || 0
        this.totalElements = pp.totalElements || 0
    }

    asQueryPage() {
        return {
            number: this.number - 1,
            size: this.size,
            page: this.page - 1
        }
    }

    static MapPageByResp = pg => {
        if (!pg) {
            return new Page()
        }
        const {number, size, totalElements, totalPages} = pg
        return new Page({
            number: number + 1,
            size: size,
            totalPages: totalPages,
            totalElements: totalElements
        })
    }

    setNum(n) {
        this.page = n
        this.number = n
    }
}
